module.exports = __webpack_public_path__ + "static/media/tuong_anime.2d8e9804.png";